import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // Search boxes are plain text: no AutoFill bar (iOS offered passwords,
    // cards and locations — Gordon 2026-10-31), no autocorrect, and the
    // keyboard's return key reads "Search". Explicit props still win.
    const searchDefaults = type === "search"
      ? { autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: false, enterKeyHint: "search" as const }
      : {};
    return (
      <input
        type={type}
        {...searchDefaults}
        className={cn(
          // No vertical padding: the h-* sets the height and an input centres
          // its own text. py-2 + border-2 left a 16px line box for 24px text on
          // h-9 fields, cropping text and placeholders (Gordon 2026-10-31).
          "flex h-10 w-full rounded-md border-2 border-input bg-card px-3 py-0 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
